<template>
  <section
    id="Tilmelding"
    class="section"
    v-if="
      this.$root.eventData.isRegistrationActive &&
        !this.$root.eventData.isEventCompleted
    "
  >
    <div class="section-header js-section-header">
      <h2>Tilmelding</h2>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Tilmelding</h5>
              <div class="container">
                <form :hidden="form.submitted" v-on:submit.prevent="onSubmit">
                  <input type="hidden" name="year" v-model="form.year" />
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="team">Holdnavn</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.team"
                          id="team"
                          name="team"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="name1">Deltager #1</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.name1"
                          id="name1"
                          name="name1"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="name1">Deltager #2</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.name2"
                          id="name2"
                          name="name2"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for="team">E-mail</label>
                        <input
                          type="email"
                          class="form-control"
                          v-model="form.email"
                          id="email"
                          name="email"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <h5>Rute</h5>
                      <div
                        class="form-check"
                        v-for="(route, index) in routes"
                        :key="route + index"
                      >
                        <span v-if="!isRouteDisabled(route)">
                          <input
                            class="form-check-input"
                            type="radio"
                            v-model="form.routes"
                            :id="'route' + index"
                            name="route"
                            :value="route"
                            :disabled="isRouteDisabled(route)"
                            required
                          />
                          <label class="form-check-label" :for="'route' + index" >
                            {{ route }} <span class="small text-muted" v-if="route === 'Lang'">(minimum 20 hold)</span>
                          </label>
                          </span>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <h5>Klasse</h5>
                      <div
                        class="form-check"
                        v-for="(gender, index) of genders"
                        :key="gender + index"
                      >
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="form.genders"
                          :id="'gender' + index"
                          name="gender"
                          :value="gender"
                          required
                        />
                        <label class="form-check-label" :for="'gender' + index">
                          {{ gender }}
                        </label>
                      </div>
                    </div>
                    <div class="col-12 my-4">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="form.accept"
                          id="accept"
                          name="accept"
                          required
                        />
                        <label class="form-check-label" for="accept">
                          Jeg har læst og accepteret
                          <a href="#Regler">reglerne</a>
                        </label>
                      </div>
                    </div>
                    <div class="col-12">
                      <button
                        type="submit"
                        class="btn btn-success btn-lg btn-block"
                        :disabled="!isValid"
                      >
                        Tilmeld
                      </button>
                    </div>
                  </div>
                </form>
                <div class="form-receipt" :hidden="!form.submitted">
                  <h2>Tak for din tilmelding!</h2>
                  <div class="row">
                    <div class="col-4">Holdnavn:</div>
                    <div class="col-8 pull-left">{{ form.team }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">Deltager #1:</div>
                    <div class="col-8 pull-left">{{ form.name1 }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">Deltager #2:</div>
                    <div class="col-8 pull-left">{{ form.name2 }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">E-mail:</div>
                    <div class="col-8 pull-left">{{ form.email }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">I skal løbe:</div>
                    <div class="col-8 pull-left">
                      {{ form.routes }} rute i klassen {{ form.genders }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Løbsgebyr</h5>
              <ul>
                <li v-if="!isRouteDisabled('Kort')">
                  {{ this.$root.eventData.routes.short.name }}:
                  {{ this.$root.eventData.routes.short.price }} DKR.
                </li>
                <li v-if="!isRouteDisabled('Lang')">
                  {{ this.$root.eventData.routes.long.name }}:
                  {{ this.$root.eventData.routes.long.price }} DKR.
                </li>
              </ul>
              <hr />
              <h5 class="card-title">Gebyret betales via en bankoverførsel:</h5>
              <ul>
                <li>Reg.: {{ this.$root.eventData.bank.reg }}</li>
                <li>Kontonr.: {{ this.$root.eventData.bank.account }}</li>
              </ul>
              <hr />
              <p class="lead">
                Husk at notere
                <strong class="font-weight-bold">{{
                  form.team || "holdnavn"
                }}</strong>
                ved overførslen!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
export default {
  name: "REGISTRATION",
  data: function() {
    return {
      routes: ["Kort", "Lang"],
      genders: ["Herre", "Dame", "Mix"],
      form: {
        year: this.$root.datetime.year,
        routes: "",
        genders: "",
        team: "",
        name1: "",
        name2: "",
        email: "",
        accept: false,
        submitted: false,
        action: "saveRegistration"
      }
    };
  },
  computed: {
    isValid: function() {
      return (
        this.form.routes &&
        this.form.genders &&
        this.form.team &&
        this.form.name1 &&
        this.form.name2 &&
        this.form.email &&
        this.form.accept
      );
    },
    
  },
  methods: {
    onSubmit: function() {
      axios
        .post("https://team-challenge.lesion.dk/core/service.php", this.form, {
          responseType: "json"
        })
        .then(response => {
          if (response.data.status === "OK") {
            this.form.submitted = true;
            this.$root.$emit("update:registrations", true);
          } else if (response.data.status === "Team taken"){
            alert("Holdnavnet er desværre allerede taget for i år..")
          } else if (response.data.status === "No accept"){
            alert("Der skete en fejl - Prøv igen")
          }
        });
    },
    isRouteDisabled: function(route){
      const key = route === 'Kort' ? 'short' : 'long';
      return !this.$root.eventData.routes[key].active;
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background-image: linear-gradient(#8bd898, #78d287);
}
</style>
